module.exports = __webpack_public_path__ + "img/ORURO.77f10dd7.png";